<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button>
        <ion-icon class="icon-menu" color="dark" name="menu"></ion-icon>
        <app-inbox-count></app-inbox-count>
      </ion-menu-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'MENU.blast' | translate }}
    </ion-title>
  </ion-toolbar>
  <ion-toolbar color="primary" class="ion-no-padding">
    <app-news-card-slide class="full-width" [newsCardSlideType]="'blast_home'" [setReady]="ready"></app-news-card-slide>
  </ion-toolbar>
</ion-header>
<ion-content color="light">
  <div class="content-div">
    <ng-container *ngIf="smsMigrate else normalBlock">
      <div class="full-width-height vertical-center">
        <div class="ion-margin ion-padding">
          <div class="ion-margin-vertical font-bold ion-text-center">
            {{ 'BLAST.upgrade.title' | translate }}
          </div>
          <div class="ion-margin-vertical ion-padding-bottom font-14 ion-text-center">
            {{ 'BLAST.upgrade.msg' | translate }}
          </div>
          <ion-button class="ion-margin-vertical" expand="block" (click)="upgradeBlastDb()">
            {{ 'BLAST.upgrade.btn' | translate}}
          </ion-button>
        </div>
        
      </div>
      
    </ng-container>
    <ng-template #normalBlock>
      <div class="font-12 ion-margin ion-text-center" (click)="goUpgrade()" *ngIf="trialMode">
        <ion-text class="font-10" [innerHTML]="'' | translate">
        </ion-text>
      </div>
    
      <ion-card class="credit-summary-card ion-padding" *ngIf="ready">
        <app-blast-credit-summary [showAvailable]="true" [showEstCount]="true" [showPricing]="true" [showBtn]="true" [ready]="ready"></app-blast-credit-summary>
      </ion-card>
      <app-blast-template-list [pageMode]="true" [ready]="ready"></app-blast-template-list>
    
      <div class="send-btn-div">
        <ion-grid class="full-width" fixed>
          <ion-row>
            <ion-col size="6">
              <ion-card class="send-btn-card ion-no-margin ion-text-center" (click)="presentTemplateManageModal('sms')" button>
                <div class="ion-text-center">
                  <ion-icon class="font-26 vertical-middle" src="./assets/wedding/icon/social/sms-round.svg"></ion-icon>
                  <ion-text class="font-12">
                    {{ 'BLAST.lbl.send_sms' | translate }}
                  </ion-text>
                </div>
              </ion-card>
            </ion-col>
            <ion-col size="6">
              <ion-card class="send-btn-card ion-no-margin ion-text-center" (click)="presentTemplateManageModal('whatsapp')" button>
                <div class="ion-text-center">
                  <ion-icon class="font-26 vertical-middle" src="./assets/wedding/icon/social/whatsapp-round.svg"></ion-icon>
                  <ion-text class="font-12">
                    {{ 'BLAST.lbl.send_whatsapp' | translate }}
                  </ion-text>
                </div>
              </ion-card>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
      
      <div class="ion-margin">
        <!-- <ion-card class="guide-card ion-no-margin">
          <ion-item lines="none" (click)="presentTemplateManageModal('sms')" detail>
            <ion-text class="font-12">
              {{ 'BLAST.lbl.send_sms' | translate }}
            </ion-text>
          </ion-item>
        </ion-card>
    
        <ion-card class="guide-card ion-no-margin">
          <ion-item lines="none" (click)="presentTemplateManageModal('whatsapp')" detail>
            <ion-text class="font-12">
              {{ 'BLAST.lbl.send_whatsapp' | translate }}
            </ion-text>
          </ion-item>
        </ion-card> -->
    
        <ion-card class="guide-card ion-no-margin">
          <ion-item lines="none" (click)="presentBlastPackageModal()" detail>
            <ion-text class="font-12">
              {{ 'BLAST.package.title' | translate }}
            </ion-text>
          </ion-item>
        </ion-card>
    
        <ion-card class="guide-card ion-no-margin">
          <ion-item lines="none" (click)="presentBlastCreditCalculatorModal()" detail>
            <ion-text class="font-12">
              {{ 'BLAST.calculator.title' | translate }}
            </ion-text>
          </ion-item>
        </ion-card>
      
        <ion-card class="guide-card ion-no-margin">
          <ion-item lines="none" (click)="presentBlastHowModal()" detail>
            <ion-text class="font-12">
              {{ 'BLAST.how.title' | translate }}
            </ion-text>
          </ion-item>
        </ion-card>
    
        <ion-card class="guide-card ion-no-margin">
          <ion-item lines="none" (click)="presentBlastTipsModal()" detail>
            <ion-text class="font-12">
              {{ 'BLAST.tips.title' | translate }}
            </ion-text>
          </ion-item>
        </ion-card>
      
      </div>
      
      <div class="ion-margin" [style.height.px]="22 + ((blastUsageList.length > 2 ? 2 : blastUsageList.length) * 96)" *ngIf="blastUsageList?.length">
        <ion-item class="history-item background-transparent ion-item-no-padding" lines="none" (click)="presentBlastCreditListModal('out')" detail>
          <ion-text class="font-12 font-bold">
            {{ 'BLAST.usage.history' | translate }}
          </ion-text>
          <ion-text class="font-12" slot="end">
            {{ 'BTN.view_all' | translate }}
          </ion-text>
        </ion-item>
        <app-blast-credit-list class="full-width-height" [pageMode]="true" [blastCreditType]="'out'" [limit]="2" [ready]="ready"></app-blast-credit-list>
      </div>
    
      <div class="ion-margin" [style.height.px]="22 + ((blastCreditList.length > 2 ? 2 : blastCreditList.length) * 96)" *ngIf="blastCreditList?.length">
        <ion-item class="history-item background-transparent ion-item-no-padding" lines="none" (click)="presentBlastCreditListModal('in')" detail>
          <ion-text class="font-12 font-bold">
            {{ 'BLAST.credit.history' | translate }}
          </ion-text>
          <ion-text class="font-12" slot="end">
            {{ 'BTN.view_all' | translate }}
          </ion-text>
        </ion-item>
        <app-blast-credit-list class="full-width-height" [pageMode]="true" [blastCreditType]="'in'" [limit]="2" [ready]="ready"></app-blast-credit-list>
      </div>
    </ng-template>
  </div>
</ion-content>
